export interface FileUploadRequest {
    file: File;
}

export function FileActions() {
    function uploadFileRequest(
        file: File
    ): FileUploadRequest {
        return {
            file: file,
        };
    }

    return {
        uploadFileRequest,
    };
}